<template>
  <div id="identity" v-loading="isLoading">
    <!-- <header-top :headerText="headerText"></header-top> -->
    <main class="main">
      <el-form label-position="left" label-width="8rem">
        <div class="form-info">
          <div class="identity-settings">
            <div class="tit">账户设置</div>
            <el-form-item label="设置项" class="auto-height">
              <el-checkbox
                v-for="(item, index) in basicIdentity"
                :key="index"
                v-model="item.value"
                >{{ item.displayName }}</el-checkbox
              >
            </el-form-item>
          </div>
          <el-form-item
            class="auto-height"
            v-for="(item, index) in identity"
            :label="item.displayName"
            :key="index"
            v-show="item.displayName != '要求唯一字符数量'"
          >
            <el-input
              v-if="item.displayName == '初始密码'"
              v-model="item.value"
              class="password"
              clearable
              :min="0"
              :placeholder="`请输入${item.displayName}`"
            ></el-input>
            <el-input-number
              v-else
              v-model="item.value"
              :min="0"
              :label="`请输入${item.displayName}`"
            ></el-input-number>
            <div class="tips">{{ item.description }}</div>
          </el-form-item>
          <div class="btn-group">
            <el-button type="primary" @click="submit" :loading="isLoadingSubmit"
              >保存</el-button
            >
            <el-button @click="reduction" :loading="isCloaseLoading"
              >取消</el-button
            >
          </div>
        </div>
      </el-form>
    </main>
  </div>
</template>

<script>
// import headerTop from "@/components/HeaderTop";

import { getIdentitySettings, updateIdentitySettings } from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  components: {
    // headerTop,
  },
  data() {
    return {
      headerText: "账户配置",
      requireData: [],
      identity: [],
      basicIdentity: [],
      permissions: this.$store.getters.permissions,
      isCloaseLoading: false,
      isLoadingSubmit: false,
      initial: [],
      isLoading: true,
    };
  },
  mounted() {
    this.getIdentitySettingsInfo();
  },
  methods: {
    submit() {
      if (this.permissions["System.IdentitySettings.Update"]) {
        this.isLoadingSubmit = true;

        this.identity.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            isVisibleToClients: item.isVisibleToClients,
            isCollection: item.isCollection,
          });
        });
        this.basicIdentity.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            isVisibleToClients: item.isVisibleToClients,
            isCollection: item.isCollection,
          });
        });
        let settings = {
          settings: this.requireData,
        };
        var query = this.$store.getters.generateUpdateSettingsParams;
        updateIdentitySettings(settings, query).then((res) => {
          this.isLoadingSubmit = false;
          if (res.code == 10200) {
            this.$message.success({
              message: `配置成功`,
              showClose: true,
            });
          }
        });
      } else {
        this.reduction();
        this.$message.warning({
          message: `您暂无账户配置权限`,
          showClose: true,
        });
      }
    },
    reduction() {
      //console.log(this.initial, 213);
      this.isCloaseLoading = true;
      this.identity = [];
      this.basicIdentity = [];
      for (var key of this.initial) {
        if (
          key.value === true ||
          key.value === false ||
          key.value === "true" ||
          key.value === "false"
        ) {
          this.basicIdentity.push(key);
        } else {
          if (key.displayName == "初始密码") {
            this.identity.unshift(key);
          } else {
            this.identity.push(key);
          }
        }
      }
      setTimeout(() => {
        this.isCloaseLoading = false;
      }, 10);
    },
    getIdentitySettingsInfo() {
      this.isLoading = true;
      this.identity = [];
      this.basicIdentity = [];
      getIdentitySettings().then((res) => {
        this.initial = deepCopy(res.result);
        for (var key of res.result) {
          if (
            key.value === true ||
            key.value === false ||
            key.value === "true" ||
            key.value === "false"
          ) {
            this.basicIdentity.push(key);
          } else {
            if (key.displayName == "初始密码") {
              this.identity.unshift(key);
            } else {
              this.identity.push(key);
            }
          }
          console.log(this.basicIdentity, "basicIdentity");
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";

#identity {
  .main {
    min-width: 900px;
    min-height: calc(100vh - 150px);
    text-align: left;

    ::v-deep .form-info {
      margin-bottom: 20px;
      padding: 20px;
      background: #fff;
      .password {
        width: 332px;
      }
      .el-form-item__content {
        padding-left: 20px;
      }
      .el-form-item__label {
        color: #333;
      }
    }
    .form-info:last-child {
      margin-bottom: 0px;
    }
    .identity-settings {
      border-radius: $--border-radius-base;
      .tit {
        margin-bottom: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .el-form-item {
        margin-bottom: 8px;
        .el-checkbox {
          margin-bottom: 15px;
          width: 260px;
        }
      }
      ::v-deep .el-form-item__content {
        .el-checkbox {
          margin-right: 0;
          .el-checkbox__label {
            padding-left: 6px;
            color: #2c3e50;
          }
        }
        .el-radio-button__inner {
          height: 30px;
          line-height: 10px;
        }
      }
    }
    .tips {
      color: #888888;
      font-size: 14px;
    }
  }
}
</style>
